import HeaderLine from '@components/HeaderLine'
import NavMenu from '@components/NavMenu'
import { Container } from "@bsf/force-ui";
import React from 'react'
import WelcomeContainer from '@components/Dashboard/WelcomeContainer';
import UltimateFeatures from '@components/Dashboard/UltimateFeatures';
import ExtendWebsite from '@components/Dashboard/ExtendWebsite';
import TemplateSection from '@components/Dashboard/TemplateSection';
import QuickAccess from '@components/Dashboard/QuickAccess';
import Widgets from '@components/Dashboard/Widgets';
import FeatureWidgets from './Features/FeatureWidgets'

const Features = () => {
    const width_class = !uaelSettingsData.hide_settings ? 'uael-65-width' : 'w-full';
    return (
        <>
            <NavMenu />
            <div className="">
                <HeaderLine />
                <Container
                    align="stretch"
                    className="p-6 flex flex-col lg:flex-row box-border"
                    containerType="flex"
                    direction="row"
                    gap="sm"
                    justify="start"
                    style={{
                        width: "100%",
                    }}
                >
                    <Container.Item
                        className={`p-2 ${width_class}`}
                        alignSelf="auto"
                        order="none"
                        shrink={1}
                    >
                        <FeatureWidgets />
                    </Container.Item>
                    {!uaelSettingsData.hide_settings && (
                        <Container.Item
                            className="p-2 uael-35-width"
                            shrink={1}
                        >
                            <TemplateSection />
                            <ExtendWebsite />

                            <QuickAccess />
                        </Container.Item>
                    )}
                </Container>
            </div>
        </>
    )
}

export default Features